module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.31681b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/bgi-dialog.png
// module id = FbJ2
// module chunks = 0